import { ComponentProps } from "react";
import styles from "./Field.module.scss";
import classNames from "classnames";

type FieldProps = {
	orientation?: "vertical" | "horizontal";
	error?: boolean;
} & ComponentProps<"div">;

const Field = ({ className, orientation = "horizontal", error, ...props }: FieldProps) => {
	return (
		<div
			role="group"
			data-orientation={orientation}
			data-invalid={error || undefined}
			className={classNames(styles["field"], className)}
			{...props}
		/>
	);
};

type FieldLabelProps = {
	htmlFor: string;
	required?: boolean;
	error?: boolean;
} & ComponentProps<"label">;

const FieldLabel = ({
	className,
	htmlFor,
	error,
	required,
	children,
	...props
}: FieldLabelProps) => {
	return (
		<label
			htmlFor={htmlFor}
			data-invalid={error || undefined}
			className={classNames(styles["field__label"], className)}
			{...props}
		>
			{children}
			{required && <span aria-hidden="true">*</span>}
		</label>
	);
};

export { Field, FieldLabel };
